export const PIPELINE = [
  { key: "nouveau_lead", label: "Nouveau lead", color: "bg-slate-500" },
  { key: "email_verifie", label: "E-mail vérifié", color: "bg-sky-500" },
  { key: "a_qualifier", label: "À qualifier", color: "bg-indigo-500" },
  { key: "qualifie", label: "Qualifié", color: "bg-blue-600" },
  { key: "a_contacter", label: "À contacter", color: "bg-violet-500" },
  { key: "contacte", label: "Contacté", color: "bg-purple-500" },
  { key: "devis_demande", label: "Devis demandé", color: "bg-amber-500" },
  { key: "devis_transmis", label: "Devis transmis", color: "bg-orange-500" },
  { key: "en_reflexion", label: "En réflexion", color: "bg-yellow-600" },
  { key: "souscription_en_cours", label: "Souscription en cours", color: "bg-teal-600" },
  { key: "gagne", label: "Gagné", color: "bg-emerald-600" },
  { key: "perdu", label: "Perdu", color: "bg-rose-600" },
  { key: "a_completer", label: "À compléter", color: "bg-gray-400" },
  { key: "aucune_offre", label: "Aucune offre disponible", color: "bg-stone-500" },
];

export const PIPELINE_MAP = Object.fromEntries(PIPELINE.map((p) => [p.key, p]));

export const ROLE_LABELS = {
  administrator: "Administrateur",
  sales_manager: "Responsable commercial",
  advisor: "Conseiller",
  read_only: "Lecture seule",
};

export const CONTACT_STATUS = [
  { key: "a_identifier", label: "À identifier" },
  { key: "a_contacter", label: "À contacter" },
  { key: "en_discussion", label: "En discussion" },
  { key: "accord_obtenu", label: "Accord obtenu" },
  { key: "integration_en_cours", label: "Intégration en cours" },
  { key: "operationnel", label: "Opérationnel" },
  { key: "suspendu", label: "Suspendu" },
];

export const needLabel = (t) => (t === "mutuelle_france" ? "Mutuelle France" : t === "expatrie" ? "Expatrié" : t || "—");
